import { createAction } from 'redux-actions';
import * as types from './change-partner-constants';

export const savePartnerRequest = createAction(types.SAVE_PARTNER_REQUEST);
export const savePartnerSuccess = createAction(types.SAVE_PARTNER_SUCCESS);
export const savePartnerFailure = createAction(types.SAVE_PARTNER_FAILURE);

export const getPartnersRequest = createAction(types.GET_PARTNERS_REQUEST);
export const getPartnersSuccess = createAction(types.GET_PARTNERS_SUCCESS);
export const getPartnersFailure = createAction(types.GET_PARTNERS_FAILURE);

export const savePartnerDetailsRequest = createAction(types.SAVE_PARTNER_DETAILS_REQUEST);
export const savePartnerDetailsSuccess = createAction(types.SAVE_PARTNER_DETAILS_SUCCESS);
export const savePartnerDetailsFailure = createAction(types.SAVE_PARTNER_DETAILS_FAILURE);

export const addPartnerDetailsRequest = createAction(types.ADD_PARTNER_DETAILS_REQUEST);
export const addPartnerDetailsSuccess = createAction(types.ADD_PARTNER_DETAILS_SUCCESS);
export const addPartnerDetailsFailure = createAction(types.ADD_PARTNER_DETAILS_FAILURE);

export const addEditedPartner = createAction(types.ADD_EDITED_PARTNER);
